export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_04.bf45a522.jpg";